import React from 'react';

const HEADING_FONT = 'Manrope, sans-serif';
const BODY_FONT = 'Inter, sans-serif';

/**
 * Statistics / Metrics Block Renderer
 * Variants: horizontal, cards, minimal
 */
export default function StatsRenderer({ props, variant }) {
  const {
    headline = '',
    items = [],
    background_color = '#1c1917',
    text_color = '#ffffff',
  } = props;

  const headerEl = headline ? (
    <div className="text-center mb-12">
      <h2
        className="text-3xl sm:text-4xl font-bold mb-3"
        style={{ fontFamily: HEADING_FONT, color: text_color }}
      >
        {headline}
      </h2>
    </div>
  ) : null;

  if (variant === 'horizontal') {
    return (
      <section className="py-16 px-6" style={{ backgroundColor: background_color }}>
        <div className="max-w-6xl mx-auto">
          {headerEl}
          <div className="flex flex-wrap items-center justify-center divide-x divide-white/20">
            {items.map((item, i) => (
              <div key={i} className="px-8 py-4 text-center">
                <div
                  className="text-4xl sm:text-5xl font-bold mb-1"
                  style={{ fontFamily: HEADING_FONT, color: text_color }}
                >
                  {item.prefix || ''}{item.value}{item.suffix || ''}
                </div>
                <div
                  className="text-sm opacity-70"
                  style={{ fontFamily: BODY_FONT, color: text_color }}
                >
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (variant === 'cards') {
    return (
      <section className="py-16 px-6" style={{ backgroundColor: background_color }}>
        <div className="max-w-6xl mx-auto">
          {headerEl}
          <div className={`grid grid-cols-2 ${items.length >= 4 ? 'lg:grid-cols-4' : items.length === 3 ? 'lg:grid-cols-3' : ''} gap-6`}>
            {items.map((item, i) => (
              <div
                key={i}
                className="p-6 rounded-xl border border-white/10 text-center"
                style={{ backgroundColor: `${text_color}10` }}
              >
                <div
                  className="text-3xl sm:text-4xl font-bold mb-2"
                  style={{ fontFamily: HEADING_FONT, color: text_color }}
                >
                  {item.prefix || ''}{item.value}{item.suffix || ''}
                </div>
                <div
                  className="text-sm opacity-70"
                  style={{ fontFamily: BODY_FONT, color: text_color }}
                >
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // Minimal variant — large numbers inline with small labels
  return (
    <section className="py-16 px-6" style={{ backgroundColor: background_color }}>
      <div className="max-w-5xl mx-auto">
        {headerEl}
        <div className="flex flex-wrap items-baseline justify-center gap-x-12 gap-y-6">
          {items.map((item, i) => (
            <div key={i} className="text-center">
              <span
                className="text-5xl sm:text-6xl font-bold"
                style={{ fontFamily: HEADING_FONT, color: text_color }}
              >
                {item.prefix || ''}{item.value}{item.suffix || ''}
              </span>
              <span
                className="block text-xs uppercase tracking-wider mt-1 opacity-60"
                style={{ fontFamily: BODY_FONT, color: text_color }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
